import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

// shared components
import JoinRoomButton from 'components/virtual/shared/JoinRoomButton'

const Actions = props => {
  const {
    roomMeeting,
    liveNow, // via RoomCardContaienr/withState
    onClickDismiss // via container
  } = props

  const { zoomPasscode } = roomMeeting

  return (
    <Box mx={2} align='center'>
      {liveNow && zoomPasscode && (
        <Typography
          my={1}
          color='error.main'
          fontWeight='fontWeightBold'
          align='center'
          variant='body1'
        >
          Zoom Passcode: {zoomPasscode}
        </Typography>
      )}
      <Box mx={1} display='inline'>
        <JoinRoomButton
          roomMeeting={roomMeeting}
          variant='contained'
          size='large'
          color='primary'
          liveNow={liveNow}
        />
      </Box>
      <Box mx={1} display='inline'>
        <Button
          onClick={onClickDismiss}
          variant='outlined'
          size='large'
          color='primary'
        >
          Maybe Later
        </Button>
      </Box>
    </Box>
  )
}

export default Actions
